/**
 * @public
 *
 * Indicates if the browser supports the input `type="date"`.
 * Useful for determining if you need a plugin to display a calendar
 * or if the browser can display it natively.
 *
 * @return {Boolean}
 */
export default function isDateSupported() {
  const i = document.createElement('input');
  i.setAttribute('type', 'date');
  return i.type !== 'text';
}
